import React from 'react'
import {Marker, Popup} from 'react-leaflet';
import {DummyForm} from "./DummyForm";
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import L from "leaflet";

import * as AppActions from "../../../../actions/app";
import * as SensorsActions from "../../../../actions/sensors";

let drag = null;

const handleMove = marker => {
    drag = marker.latlng;
};

const DummyPoint = (props) => {

    const size = Math.pow(1.23, props.zoom) - 8;
    const style = `"width: ${size}px !important; height: ${size}px !important;"`;

    const icon = L.divIcon({
        html: `<div class='sensor' style=${style}></div>`
    });

    return (

        <Marker
            key={props.key}
            icon={icon}
            position={props.data.location.coordinates}
            draggable={props.isAdmin}
            onDragEnd={() => props.sensorsActions.moveSensor(props.map, drag, props.arrayIndex)}
            onMove={handleMove}
            arrayIndex={props.arrayIndex}
            onClick={props.onClick}
        >
            <Popup onClose={props.appActions.disableIoTTab}>
                <DummyForm
                    storeDummie={(value) => props.sensorsActions.updateSensor(props.map, value, props.arrayIndex)}
                    deleteSingleDummie={() => props.sensorsActions.deleteSensor(props.map, props.arrayIndex, props.data.id)}
                    id={props.data.id}
                    coordinates={props.data.location.coordinates}
                    // TODO value={props.isAdmin ? props.data.timestampValue : props.data.value}
                    value={props.data.value}
                    isAdmin={props.isAdmin}
                    adminValue={props.isAdmin ? props.data.value : null}
                />
            </Popup>
        </Marker>

    );

};

const mapDispatchToProps = (dispatch) => {
    return {
        sensorsActions: bindActionCreators(SensorsActions, dispatch),
        appActions: bindActionCreators(AppActions, dispatch),
    }
};

export default connect(null, mapDispatchToProps)(DummyPoint)


// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/sensors/DummyPoint.js